var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 77,
    viewBox: "0 0 270 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.703 8.75216L152.483 8.58609C149.679 6.55499 145.75 7.08642 143.589 9.83611C141.428 12.5851 141.832 16.5385 144.458 18.796L144.671 18.9703C155.57 27.5766 162.25 39.5042 164.271 52.235L164.31 52.4873L164.315 52.518L164.379 52.8076C165.619 58.1803 168.825 62.8846 173.403 66.4984C184.663 75.3911 200.985 73.4498 209.856 62.1627C218.729 50.8762 216.792 34.5176 205.531 25.6259C200.839 21.9213 195.269 20.0969 189.725 20.0457L189.644 19.9831C189.191 20.0189 188.738 20.0483 188.283 20.0719L187.55 20.1066C175.391 20.5843 163.009 16.8902 152.703 8.75216Z",
    fill: "#024066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.042 74.1684C258.378 74.1684 270 62.5201 270 48.1517C270 33.783 258.378 22.1348 244.042 22.1348C229.706 22.1348 218.084 33.783 218.084 48.1517C218.084 62.5201 229.706 74.1684 244.042 74.1684Z",
    fill: "#05D1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.13466e-06 48.0383C-1.7613e-06 33.6699 11.6218 22.0215 25.958 22.0215C31.9309 22.0215 37.4318 24.0434 41.8179 27.4412C51.2655 36.1884 63.9982 41.5338 77.8742 41.5338C91.7493 41.5338 104.482 36.1884 113.93 27.4412C118.316 24.0434 123.817 22.0215 129.79 22.0215C144.126 22.0215 155.748 33.6699 155.748 48.0383C155.748 62.407 144.126 74.0552 129.79 74.0552C123.817 74.0552 118.316 72.0335 113.93 68.6356C104.482 59.8885 91.7493 54.5425 77.8742 54.5425C63.9982 54.5425 51.2655 59.887 41.8179 68.6341C37.4318 72.0335 31.9309 74.0552 25.958 74.0552C11.6218 74.0552 -5.08003e-07 62.407 -1.13466e-06 48.0383Z",
    fill: "#024066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColapsed);
export default __webpack_public_path__ + "static/media/logo-colapsed.36ab23d2faf0ead39bcf2cb5b36827fd.svg";
export { ForwardRef as ReactComponent };